import { Alert, Box } from "@mui/material";
import {
	BooleanInput,
	DateField,
	DeleteButton,
	Edit,
	Labeled,
	maxValue,
	minValue,
	NumberInput,
	required,
	SaveButton,
	SimpleForm,
	TextInput,
	Toolbar,
	useRecordContext,
} from "react-admin";
import { RestoreButton } from "@/components/RestoreButton";

const ReferralLinkEditToolbar = () => {
	const record = useRecordContext();

	return (
		<Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
			<SaveButton />
			<Box>
				{record?.deletedAt && <RestoreButton resource="referral-links" />}
				<DeleteButton />
			</Box>
		</Toolbar>
	);
};

const DeletedAlert = () => {
	const record = useRecordContext();
	if (!record?.deletedAt) return null;

	return (
		<Alert severity="warning" sx={{ mb: 2 }}>
			This referral link was deleted on{" "}
			{new Date(record.deletedAt).toLocaleDateString()}. You can restore it
			using the Restore button below.
		</Alert>
	);
};

const ApprovedAlert = () => {
	const record = useRecordContext();
	if (!record?.partnerAgreedAt) return null;

	return (
		<Alert severity="info" sx={{ mb: 2 }}>
			Partner approved on{" "}
			{new Date(record.partnerAgreedAt).toLocaleDateString()}. Changes to
			financial terms will be recorded in the audit log.
		</Alert>
	);
};

const PendingApprovalAlert = () => {
	const record = useRecordContext();
	if (record?.partnerAgreedAt || record?.deletedAt) return null;

	return (
		<Alert severity="warning" sx={{ mb: 2 }}>
			Awaiting partner approval. This link cannot be used for attribution until
			the partner approves the terms.
		</Alert>
	);
};

const FinancialFieldsSection = () => (
	<>
		<NumberInput
			source="commissionPercent"
			label="Commission %"
			validate={[required(), minValue(0), maxValue(100)]}
		/>
		<NumberInput
			source="attributionWindowDays"
			label="Attribution Window (days)"
			helperText="Leave empty to use app default"
		/>
	</>
);

export const ReferralLinkEdit = () => (
	<Edit>
		<DeletedAlert />
		<ApprovedAlert />
		<PendingApprovalAlert />
		<SimpleForm toolbar={<ReferralLinkEditToolbar />}>
			<TextInput source="id" disabled />
			<TextInput source="code" validate={required()} fullWidth />
			<TextInput source="appId" disabled />
			<TextInput source="appName" disabled label="App" />
			<TextInput source="partnerId" disabled />
			<TextInput source="partnerName" disabled label="Partner" />
			<FinancialFieldsSection />
			<BooleanInput source="active" />
			<Labeled label="Partner Approval">
				<DateField source="partnerAgreedAt" emptyText="Pending" />
			</Labeled>
		</SimpleForm>
	</Edit>
);
